<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40"><path d="M16.652.614a.4.4 0 0 1 .7 0L33.662 29.4a.4.4 0 0 1-.348.6H.686a.4.4 0 0 1-.348-.6z" style="fill:#e4e8ee" transform="translate(3 5)" fill="currentColor"/><path d="M15516 2986v-2h2v2zm0-4v-9h2v9z" style="fill:#a0a9b8" transform="translate(-15497 -2956)" fill="currentColor"/></svg>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ri-alert',
});
</script>
